import styled from 'styled-components';
import { Flex } from 'antd';
import { SbForm, SbSelect } from 'uiCore';

// ── Styled Form.Item (label override) ────────────────────────────────────────

export const SbFormItemStyled = styled(SbForm.Item)`
  .ant-form-item-label > label {
    color: ${p => p.theme?.colors?.dark ?? '#2B3034'};
  }

`;

export const FixedHeight = styled(SbSelect)`
  min-height: 32px;
  display: flex;
  align-items: center;
`;

// ── Uploaded file pill ────────────────────────────────────────────────────────

export const UploadedFilePillStyled = styled(Flex)`
    margin-top: 8px;
    padding: 6px 12px;
    background: ${p => p.theme?.colors?.light ?? '#F7F7F7'};
    border-radius: 6px;
`;

export const UploadedFileNameStyled = styled.span`
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
`;

// ── Error message box ─────────────────────────────────────────────────────────

